const config = {
    timeout:30000,//超时，超过30000，请求终止
    nav_menu:[//导航菜单
      
    ],
    banner:[
        {
            img:require('@/assets/images/banner1.png'),
            title:""
        },
        {
            img:require('@/assets/images/banner2.jpg'),
            title:""
        },
        // {
        //     img:require('@/assets/images/banner3.jpg'),
        //     title:""
        // },
    ],
    menu_nav:[
        {
            name:'首页',
            enName:'Home',
            path:'/home',
            children:[],
        },
        {
            name:'产品中心',
            enName:'Products',
            path:'/product',
            children:[]
        },
        {
            name:'新闻中心',
            enName:'News',
            path:'/news',
            children:[]
        },
        {
            name:'关于我们',
            enName:'About Us',
            path:'/about',
            children:[],
        },
        {
            name:'联系我们',
            enName:'Contact Us',
            path:'/contact',
            children:[],
        }
    ],
    footer_nav:[
        {
            name:'产品中心',
            enName:'Product Center',
            url:'/product',
        },
        {
            name:'新闻中心',
            enName:'News Center',
            url:"/solution",
        },
        {
            name:'关于我们',
            enName:'About Us',
            url:'/about',
            
        },
        {
            name:'联系我们',
            enName:'Contact Us',
            url:"/contact",
        },
    ]
}
export default config


// WEBPACK FOOTER //
// ./config/project-config.js